// The welcome-back offer for the signed-in user (lib/welcomeBack), shared by
// the paywall and the bar so it's fetched once. null when they don't have
// one. Only asks when `enabled` (no live plan).
import { useQuery } from "react-query";
import { getIdToken } from "../../utils/firebaseAuth";

export const useWelcomeBack = (uid, enabled = true) =>
  useQuery(
    ["welcome-back", uid],
    async () => {
      const token = await getIdToken();
      const r = await fetch("/api/payment/welcome-back", {
        method: "POST",
        headers: { Authorization: token || "" },
      });
      return (await r.json())?.offer ?? null;
    },
    {
      enabled: !!uid && enabled,
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
